'use strict';

import type { IndPolicy } from '../../Entities/Ind/IndPolicy';
import { EntityCollection } from '../EntityCollection';

export class IndPolicyCollection extends EntityCollection<IndPolicy> {}
